import { getDataAutomationGroup } from "@/helpers";
import { FC } from "react";

type InteractiveCardProps = {
  children?: React.ReactNode;
  header?: string;
  optionalText?: string;
};

const InteractiveCard: FC<InteractiveCardProps> = ({
  children,
  header,
  optionalText,
}) => {
  return (
    <div
      className="bg-swdc-cool-gray-100 relative flex min-h-52 w-full min-w-0 flex-col self-stretch p-4"
      {...getDataAutomationGroup("card")}
    >
      <div className="relative flex w-full items-start">
        <svg
          width={16}
          fill="none"
          className="absolute top-3 left-0"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8 8 0 0h8l8 8-8 8H0Z" fill="#ff6200" />
        </svg>
        <div className="flex flex-row items-center justify-center">
          <p className="text-subhead-xl text-swdc-black-600 ml-6 font-bold">
            {header}
          </p>
          {optionalText && (
            <p className="text-subhead-s text-swdc-gray-300 ml-2 font-medium">
              {optionalText}
            </p>
          )}
        </div>
      </div>
      <div className="grow">{children}</div>
    </div>
  );
};

export default InteractiveCard;
